
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parceria/censo/[id]",
      function () {
        return require("private-next-pages/parceria/censo/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parceria/censo/[id]"])
      });
    }
  